module.exports = __webpack_public_path__ + "static/media/5.eb21c0c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hair/5.png
// module id = 1285
// module chunks = 0